import * as React from 'react';
import { View, StyleSheet } from 'react-native';
import Animated, { useAnimatedStyle, useSharedValue, withTiming } from 'react-native-reanimated';
import { rem } from 'design-system/values';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import { useAppSelector } from 'store/hooks';
import createStyleSheets from 'utils/createStyleSheets';
import { useMainStackRoute } from 'utils/types/navigationV6';
import { selectBuyAndSellPoints } from '../reducers/selectors';
import { BUY_SELL_INDICATOR_VERTICAL_PADDING } from '../constants';
import SelectedBuySellInfoView from './SelectedBuySellInfoView';
const correction = -rem(4);
const emptyPointsToShow = [];
const LineBuyAndSellIndicatorsView = ({ width, height, pointsToShow }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const opacity = useSharedValue(0);
    React.useEffect(() => {
        opacity.value = 0;
        opacity.value = withTiming(1);
    }, [opacity, pointsToShow]);
    const animatedStyles = useAnimatedStyle(() => ({
        opacity: opacity.value,
    }), [opacity]);
    return (<Animated.View style={[styles.container, animatedStyles]} pointerEvents="none">
      {pointsToShow.map((point) => (<View key={point.x} style={[
                styles.point,
                {
                    left: point.x * width + correction,
                    top: point.y * height + correction,
                    backgroundColor: colors.elements[point.colorKey],
                },
            ]}>
          <View style={styles.innerPoint}/>
        </View>))}
    </Animated.View>);
};
const LineBuyAndSellIndicators = ({ width, height, points, points2, selectedPeriod, selectedInfoObj, }) => {
    const route = useMainStackRoute();
    const assetId = 'assetId' in route.params ? route.params.assetId : undefined;
    const styles = useStyles(styleSet);
    const [pointsToShow, setPointsToShow] = React.useState(emptyPointsToShow);
    const buySellPoints = useAppSelector((state) => selectBuyAndSellPoints(state, assetId, selectedPeriod, points, points2));
    React.useEffect(() => {
        setPointsToShow([]);
        const timeout = setTimeout(() => {
            setPointsToShow(buySellPoints ?? emptyPointsToShow);
        }, 300);
        return () => {
            clearTimeout(timeout);
        };
    }, [buySellPoints]);
    if (!pointsToShow.length) {
        return null;
    }
    return (<View style={styles.mainContainer} pointerEvents="none">
      <LineBuyAndSellIndicatorsView width={width} height={height} pointsToShow={pointsToShow}/>
      <SelectedBuySellInfoView width={width} selectedInfoObj={selectedInfoObj} pointsToShow={pointsToShow}/>
    </View>);
};
export default React.memo(LineBuyAndSellIndicators);
const styleSet = createStyleSheets((colors) => ({
    mainContainer: {
        ...StyleSheet.absoluteFillObject,
        zIndex: 100,
    },
    container: {
        ...StyleSheet.absoluteFillObject,
        top: BUY_SELL_INDICATOR_VERTICAL_PADDING,
        bottom: BUY_SELL_INDICATOR_VERTICAL_PADDING,
    },
    point: {
        width: rem(8),
        height: rem(8),
        borderRadius: rem(8),
        position: 'absolute',
        alignItems: 'center',
        justifyContent: 'center',
    },
    innerPoint: {
        width: rem(4),
        height: rem(4),
        borderRadius: rem(4),
        backgroundColor: colors.cards.onDark,
    },
}));
